var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "panel", style: { "--color": "#FF6637" } },
    [_c("div", { staticClass: "R" }, [_c("router-view")], 1), _c("left")],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }